import { ThreeDotsLoaderAnimatedSvg } from "../Svgs";
import { IGatewayMerchantResolverViewProps } from "./GatewayMerchantResolver";

export const View = (props: IGatewayMerchantResolverViewProps) => {
  const {
    isLoading,
    isError,
    isGatewayMerchantResolved,
    merchantName,
    errorMessage,
  } = props;

  return isLoading || isGatewayMerchantResolved || isError ? (
    <div className="gateway-merchant-resolver--container">
      {isLoading ? (
        <ThreeDotsLoaderAnimatedSvg fill={"#3b7cff"} height={5} width={30} />
      ) : !merchantName ? null : (
        <span className="text-primary">{merchantName}</span>
      )}
      {isError ? <div className="text-danger">{errorMessage}</div> : null}
    </div>
  ) : null;
};
